 /*eslint-disable import/no-anonymous-default-export*/
export default {
    UPDATE_VENDOR: () => `/vendor/auth/updateProfile`,
    UPDATE_DRIVER: (id) => `/vendor/drivers/updateMyDriver/${id}`,
    GET_VENDOR: () => `/vendor/auth/profile`,
    GET_DRIVER: () => `/vendor/drivers/myDrivers`,
    ADD_DRIVER: () => `/vendor/drivers/registerDriver`,
  };
  